/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';
import {RoleResource} from '../../../components/api/resources/resource/role.resource';

@Component({
  standalone: false,
  selector: 'adn-role-route-page',
  template: `
    <adn-role-list-page
      *ngIf="list"
      [list]="list">
    </adn-role-list-page>
  `
})
export class RoleRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(RoleResource) private readonly Role: any
  ) {
  }

  ngOnInit(): void {
    this.adnListHelper.setUpList(this.list, this.Role, false, 'fullRoleList', {
      baseTable: 'role'
    });
  }
}
